<template>
  <section class="panel" :class="{ 'panel-focus': focus && open, 'panel-collapsed': !open }">
    <div class="panel-head" @click="toggle">
      <button type="button" class="chev" :aria-expanded="open ? 'true' : 'false'">{{ open ? '▾' : '▸' }}</button>
      <h2 class="panel-title">{{ title }}</h2>
      <span v-if="meta && open" class="panel-meta">{{ meta }}</span>
    </div>
    <div v-show="open" class="panel-body"><slot /></div>
  </section>
</template>

<script>
export default {
  name: 'CollapsePanel',
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    meta: { type: String, default: '' },
    focus: { type: Boolean, default: false },
  },
  data() {
    let open = true;
    try { open = sessionStorage.getItem(`pvisPanel-${this.id}`) !== 'closed'; } catch (e) { /* ignore */ }
    return { open };
  },
  methods: {
    toggle() {
      this.open = !this.open;
      try { sessionStorage.setItem(`pvisPanel-${this.id}`, this.open ? 'open' : 'closed'); } catch (e) { /* ignore */ }
    },
  },
};
</script>

<style scoped>
.panel-head {
  display: flex; align-items: baseline; gap: 10px; margin-bottom: 6px; flex-wrap: wrap;
  cursor: pointer; user-select: none;
}
.chev {
  background: none; border: none; padding: 0; cursor: pointer;
  font-size: 13px; color: var(--muted); width: 14px; flex-shrink: 0;
}
.panel-head:hover .chev { color: var(--red); }
.panel-title { font-size: 18px; font-weight: 800; letter-spacing: -0.01em; margin: 0; }
.panel-meta { font-size: 10.5px; color: var(--muted); margin-left: auto; }
.panel-collapsed { padding-bottom: 12px; }
.panel-collapsed .panel-head { margin-bottom: 0; }
</style>
